export default __webpack_public_path__ + "static/gt40froint-cb92ce51043741153fb721b5bde6a5bc.png";